function apresentarDecimal(valor) {
    if (valor) {
        return valor.toString().replace('.', ',');
    }
    return
}

export default apresentarDecimal;